import { tss } from "tss-react/mui";

export const useShopHeroSectionStyles = tss.withName("ShopHeroSection").create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.primary[50],
        padding: "56px 4% 40px",
    },
    container: {
        maxWidth: "1640px",
        margin: "0 auto",
    },
    breadcrumb: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1.5),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        fontSize: "0.85rem",
    },
    breadcrumbLink: {
        color: theme.palette.text.secondary,
        textDecoration: "none",
        "&:hover": { color: theme.palette.primary.main },
    },
    description: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1.5),
        maxWidth: 640,
    },
}));
